import SupportMentorCalendar from 'src/supportPortal/components/common/mentor/mentorCalendar/SupportMentorCalendar'

export default function TherapistBookings() {
  return <SupportMentorCalendar />
}
